$(document).ready(function(){
    loadCustomProductsData();
});

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    loadCustomProductsData();
    
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    loadCustomProductsData();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    loadCustomProductsData();
});

function loadCustomProductsData() {
    if($('.product').length){
        $('.product').each(function() {
            if($(this).find('.price-standard').length){
                $(this).find('.prices').prepend($(this).find('.price-standard'))
            }
            if($(this).find('.flags-default').length){
                $(this).find('.p-in-in').append($(this).find('.flags-default').clone())
            }
            else{
                $(this).find('.p-in-in').append('<div class="flags flags-default"></div>')
            }

        });
    }
}